// extracted by mini-css-extract-plugin
export default {"field":"CommentCreate_field__h8QBR"};